import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState(false)

  React.useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }

    // Verificação inicial
    checkMobile()

    // Listener para mudanças de tamanho
    const handleResize = () => {
      checkMobile()
    }

    window.addEventListener("resize", handleResize)
    
    // Usar matchMedia para uma detecção mais precisa
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(mql.matches)
    }
    
    if (mql.addEventListener) {
      mql.addEventListener("change", onChange)
    } else {
      // Fallback para navegadores mais antigos
      mql.addListener(onChange)
    }

    return () => {
      window.removeEventListener("resize", handleResize)
      if (mql.removeEventListener) {
        mql.removeEventListener("change", onChange)
      } else {
        mql.removeListener(onChange)
      }
    }
  }, [])

  return isMobile
}
